// third-party
import { FormattedMessage } from 'react-intl';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
// assets
import {
  CallCalling,
  ClipboardTick,
  Lock,
  MoneySend,
  Profile,
  UserEdit
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  profile:Profile,
  details:UserEdit,
  changePassword:Lock,
  myAttendance:ClipboardTick,
  followUps:CallCalling,
  expenses:MoneySend
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const profiles: NavItemType = {
  id: 'group-profiles',
  title: <FormattedMessage id="profiles"  />,
  icon: icons.profile,
  type: 'collapse',
  // url:'profile/my-attendance',
  permissions:['NL_PROFILE_R'],
  children: [
    {
      id: 'my-attendance',
      title: <FormattedMessage id="my-attendance" />,
      type: 'item',
      url: '/profile/my-attendance',
      icon: icons.myAttendance,
      permissions:['NL_PROFILE_MY_ATTENDANCE_R','NL_PROFILE_MY_ATTENDANCE_U'],
      breadcrumbs: true
    },
    {
      id: 'my-tasks',
      title: <FormattedMessage id="my-tasks" />,
      type: 'item',
      url: '/profile/my-tasks',
      icon: PendingActionsIcon,
      permissions:['NL_PROFILE_MY_TASKS_R','NL_PROFILE_MY_TASKS_C','NL_PROFILE_MY_TASKS_U','NL_PROFILE_MY_TASKS_D','NL_PROFILE_MY_TASKS_L'],
      breadcrumbs: true,
    },
    {
      id: 'my-follow-ups',
      title: <FormattedMessage id="my-follow-ups" />,
      type: 'item',
      url: '/profile/my-follow-ups',
      icon: icons.followUps,
      permissions:['NL_PROFILE_MY_FOLLOW_UP_R','NL_PROFILE_MY_FOLLOW_UP_C','NL_PROFILE_MY_FOLLOW_UP_U','NL_PROFILE_MY_FOLLOW_UP_D','NL_PROFILE_MY_FOLLOW_UP_L'],
      breadcrumbs: true
    },
    {
      id: 'my-expenses',
      title: <FormattedMessage id="my-expenses" />,
      type: 'item',
      url: '/profile/my-expenses',
      icon: icons.expenses,
      permissions:['NL_PROFILE_MY_EXPENSES_R','NL_PROFILE_MY_EXPENSES_C','NL_PROFILE_MY_EXPENSES_U','NL_PROFILE_MY_EXPENSES_D','NL_PROFILE_MY_EXPENSES_L'],
      breadcrumbs: true
    },
    // {
    //   id: 'my-leaves',
    //   title: <FormattedMessage id="my-leaves" />,
    //   type: 'item',
    //   url: '/profile/my-leave-applications',
    //   icon: icons.myAttendance,
    //   permissions:['NL_PROFILE_MY_LEAVES_R','NL_PROFILE_MY_LEAVES_C','NL_PROFILE_MY_LEAVES_U','NL_PROFILE_MY_LEAVES_D','NL_PROFILE_MY_LEAVES_L'],
    //   breadcrumbs: true
    // },
    // {
    //   id: 'my-details',
    //   title: <FormattedMessage id="my-profile" />,
    //   type: 'item',
    //   url: '/profile',
    //   icon: icons.details,
    //   breadcrumbs: true
    // },
    // {
    //   id: 'my-change-password',
    //   title: <FormattedMessage id="my-change-password" />,
    //   type: 'item',
    //   url: '/profile/change-password',
    //   icon: icons.changePassword,
    //   breadcrumbs: true
    // }
  ]
};

export default profiles;
